var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.series.length)?_c('apexchart',{key:_vm.heatmapKey,attrs:{"type":"heatmap","width":"100%","height":"100%","options":_vm.options,"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }